/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of ItemHistoryClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfList_1OfCostHistory,
  SuccessResponse_1OfList_1OfItemDailyHistory,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockCostHistories = [
  { id: 1, itemNumber: 'ITEM001', date: '2025-12-01', costPrice: 5.50, previousCostPrice: 5.00 },
  { id: 2, itemNumber: 'ITEM001', date: '2025-11-15', costPrice: 5.00, previousCostPrice: 4.80 },
];

const mockDailyHistories = [
  { date: '2025-12-12', openingStock: 100, closingStock: 85, sales: 15, received: 0 },
  { date: '2025-12-11', openingStock: 110, closingStock: 100, sales: 20, received: 10 },
  { date: '2025-12-10', openingStock: 95, closingStock: 110, sales: 10, received: 25 },
];

/* ---- Mocked Client Implementation ---- */

import { IItemHistoryClient } from '../../interfaces';
export class ItemHistoryClientMocked implements IItemHistoryClient {
  constructor(baseUrl?: string) {}

  async getitemcosthistoriesbyitemnumber(
    itemNumber: string,
    storeNumber: string,
    date?: string,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfList_1OfCostHistory> {
    await delay();
    const histories = mockCostHistories.filter((h) => h.itemNumber === itemNumber);
    return successResponse(histories) as SuccessResponse_1OfList_1OfCostHistory;
  }

  async getitemdailyhistory(
    itemNumber: string,
    storeNumber: string,
    fromDate: string,
    toDate: string,
    cancelToken?: CancelToken
  ): Promise<SuccessResponse_1OfList_1OfItemDailyHistory> {
    await delay();
    const histories = mockDailyHistories.filter((h) => h.date >= fromDate && h.date <= toDate);
    return successResponse(histories) as SuccessResponse_1OfList_1OfItemDailyHistory;
  }

  // ====== Auto-generated stub methods ======








  // ====== Auto-generated stub methods ======




















}
